import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';

import { IBusinessPlanType } from 'interfaces/businessPlan';
import { ISubscriptionPlan, SUBSCRIPTION_PLAN } from 'interfaces/subscriptions';

import {
  COPY,
  FOR_BANK_TYPE_ACTION_LIST,
  FREE_SUBSCRIPTION_ACTIONS_LIST,
  LIGHT_SUBSCRIPTION_ACTIONS_LIST,
  ONE_PAGE_TYPE_ACTION_LIST,
  STANDARD_SUBSCRIPTION_ACTIONS_LIST,
  STARTER_SUBSCRIPTION_ACTIONS_LIST,
  UNAUTHORIZED_SUBSCRIPTION_ACTIONS_LIST,
  VIEWONLY_ACTIONS_LIST,
} from './constants';
import { ICardActionProperties } from './types';

const actionListsByPlan = {
  [SUBSCRIPTION_PLAN.STARTER]: STARTER_SUBSCRIPTION_ACTIONS_LIST,
  [SUBSCRIPTION_PLAN.FREE]: FREE_SUBSCRIPTION_ACTIONS_LIST,
  [SUBSCRIPTION_PLAN.LIGHT]: LIGHT_SUBSCRIPTION_ACTIONS_LIST,
  [SUBSCRIPTION_PLAN.STANDARD]: STANDARD_SUBSCRIPTION_ACTIONS_LIST,
  [SUBSCRIPTION_PLAN.UNAUTHORIZED]: UNAUTHORIZED_SUBSCRIPTION_ACTIONS_LIST,
  viewonly: VIEWONLY_ACTIONS_LIST,
};

const actionListByDocumentType = {
  [BUSINESS_PLAN_TYPES.ONE_PAGE]: ONE_PAGE_TYPE_ACTION_LIST,
  [BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT]: ONE_PAGE_TYPE_ACTION_LIST,
  [BUSINESS_PLAN_TYPES.FOR_BANK]: FOR_BANK_TYPE_ACTION_LIST,
  [BUSINESS_PLAN_TYPES.FOR_INVESTORS]: FOR_BANK_TYPE_ACTION_LIST,
};

interface IGetCardActionsListOptions {
  actionsList: ICardActionProperties[];
  viewonly: boolean;
  userSubscriptionPlan: ISubscriptionPlan | undefined;
  availabilityCount: number;
  type: IBusinessPlanType;
}

export const getCardActionsList = ({
  actionsList,
  viewonly,
  userSubscriptionPlan,
  availabilityCount,
  type,
}: IGetCardActionsListOptions): ICardActionProperties[] => {
  const planKey = viewonly ? 'viewonly' : userSubscriptionPlan;
  const relevantActionsList = planKey ? actionListsByPlan[planKey] : [];
  const actionsListByDocType = actionListByDocumentType[type];

  // add 'share' to one page BP
  if (planKey === 'STARTER' && (type === 'ONE_PAGE' || type === 'ONE_PAGE_SHORT')) {
    relevantActionsList.push('share');
  }

  return actionsList
    .map((eachAction) => {
      eachAction.disabled =
        !relevantActionsList.includes(eachAction.id) || (eachAction.id === COPY && availabilityCount <= 0);
      return eachAction;
    })
    .filter(({ id }) => actionsListByDocType?.includes(id));
};
